// Single source of truth for the cities and neighborhoods we serve.
// Cities with a `path` have a dedicated location page (see App.tsx routes).

export interface ServiceArea {
  name: string;
  path: string;
  neighborhoods: string[];
}

export const SERVICE_AREAS: ServiceArea[] = [
  { name: 'Ventura', path: '/ventura', neighborhoods: ['Midtown Ventura', 'East Ventura'] },
  { name: 'Oxnard', path: '/oxnard', neighborhoods: ['Riverpark'] },
  { name: 'Camarillo', path: '/camarillo', neighborhoods: ['Spanish Hills', 'Camarillo Heights'] },
  { name: 'Thousand Oaks', path: '/thousand-oaks', neighborhoods: ['Oak Park'] },
  { name: 'Newbury Park', path: '/newbury-park', neighborhoods: ['Dos Vientos', 'Lynn Ranch'] },
  { name: 'Westlake Village', path: '/westlake-village', neighborhoods: [] },
  { name: 'Simi Valley', path: '/simi-valley', neighborhoods: [] },
  { name: 'Moorpark', path: '/moorpark', neighborhoods: [] },
  { name: 'Ojai', path: '/ojai', neighborhoods: [] },
  { name: 'Santa Paula', path: '/santa-paula', neighborhoods: [] },
  { name: 'Fillmore', path: '/fillmore', neighborhoods: [] },
  { name: 'Port Hueneme', path: '/port-hueneme', neighborhoods: [] },
];
